<template>
  <b-container fluid class="mt-4">
    <b-table-simple>
      <b-tr
        v-for="{ logicode, img, cnt, title, status } in orderItems"
        :class="{ 'text-through': status === 5 }"
      >
        <b-td>
          {{ logicode }}
        </b-td>
        <b-td class="text-center">
          <b-img width="100" height="100" :src="img" />
          <div :class="{ 'text-danger': cnt > 1 }">x {{ cnt }}</div>
        </b-td>
        <b-td>
          {{ title }}
        </b-td>
        <b-td>
          {{ status }}
        </b-td>
      </b-tr>
    </b-table-simple>
  </b-container>
</template>

<script>
// import 'axios-progress-bar/dist/nprogress.css'
// import { loadProgressBar } from 'axios-progress-bar'
//
// loadProgressBar()

//you need to import the CSS manually (in case you want to override it)
import { required } from "vee-validate/dist/rules";

export default {
  name: "SubmitId",
  metaInfo: {
    title: "주문상품목록",
  },
  components: {},
  data() {
    return {
      orderItems: [
        {
          img: "",
          cnt: 0,
          title: "",
        },
      ],
    };
  },
  computed: {
    formData() {},
  },
  methods: {
    async init() {
      const { stnum } = this.$route.query;
      this.orderItems = await this.$get("/tnum-item-list", {
        params: { stnum },
      });
    },
  },
  watch: {
    currentPage(newPage) {
      console.log(newPage);
      this.$router.push({
        params: { page: newPage },
        query: this.$route.query,
      });
      this.init();
    },
    $route: "init",
    "$store.state.user.nick": "init",
  },
  async mounted() {
    this.init();
  },
};
</script>
<style>
.table-canceled {
  text-decoration: line-through;
}

.table-canceling {
  background-color: lightgray;
  text-decoration: line-through;
}

.manage-data {
  width: 19%;
  display: inline;
  margin-right: 1%;
}

.hidden_header {
  display: none;
}
</style>
